import { EnterFullScreen } from '@/components/icons/video/enter-fullscreen';
import { useVideoStore } from '../hooks/useVideoStore';
import { Button } from './Button';
import { useIsMobileDevice } from '../hooks/useIsMobileDevice';

export function FullscreenButton() {
  const { toggleFullscreen } = useVideoStore((state) => ({
    toggleFullscreen: state.toggleFullscreen,
  }));

  const isMobileDevice = useIsMobileDevice();

  return (
    <Button
      label="Enter fullscreen"
      icon={<EnterFullScreen />}
      onClick={() => toggleFullscreen(isMobileDevice)}
    />
  );
}
